import { Button } from "react-bootstrap";

const SessionTrackingButton = ({
  element,
  selected,
  onClick,
  disabled,
  color,
  value,
  onValueChange,
  sessionIndex,
  isSessionTrail,
  trackingIndex,
  isDisabled }) => {
  const handleInputChange = (e) => {
    let newValue = e.target.value;

    // Remove anything that is NOT a digit
    newValue = newValue.replace(/[^0-9]/g, '');

    // Limit to max 10
    if (newValue === '' || Number(newValue) <= 1000) {
      onValueChange(sessionIndex, trackingIndex, element, newValue);
    }
  };

  return (
    <>
      <div
        className="goal-track d-flex align-items-center justify-content-center rounded-circle themeBlue"
        // style={{ backgroundColor: selected ? "#ac5c9a" : "#fff" }}
        style={{
          height: "30px",
          width: "30px",
          border: isSessionTrail ? "0.5px solid #00000073" : `3px solid ${color}`,
          background: "#fff",
        }}
      >
        <Button className={`fw-bold`} style={{ border: "none", opacity: "1", fontSize: "14px" }} variant="transparent" disabled={isSessionTrail}>
          {element}
        </Button>

        <div
          className="position-absolute"
          style={{
            top: "100%",
            height: "20px",
            borderLeft: isSessionTrail ? "2px solid #00000073" : `2px solid ${color}`,
          }}
        >
          <div className="position-absolute"
            style={{
              top: "100%",
              right: -25
            }}
          >
            <input
              disabled={isSessionTrail || isDisabled}
              onKeyDown={(e) => {
                if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              type="number"
              min={0}
              style={{
                width: "50px",
                height: "36px",
                outline: "none",
                textAlign: "right" // This will align the text to the right
              }}
              value={value || ''}
              onChange={handleInputChange}
              className="session-input-no-spinner"
            />
          </div>
        </div>
      </div >
    </>
  );
}

export default SessionTrackingButton;
